module.exports = __webpack_public_path__ + "img/sklo@2x.e469e48a.webp";